<admin-app-header></admin-app-header>

<div class="container-fluid py-4">
    <div class="row">
        <div class="col-12">
            <div class="card shadow-sm">
                <div class="card-header bg-primary text-white">
                    <div class="row align-items-center">
                        <div class="col-md-6">
                            <h4 class="mb-0">
                                <i class="fas fa-users me-2"></i>
                                Parking Leads Management
                            </h4>
                            <small>Total: {{ filteredLeads.length }} leads</small>
                        </div>
                        <div class="col-md-6 text-end">
                            <button class="btn btn-light btn-sm me-2" (click)="viewOnMap()">
                                <i class="fas fa-map-marker-alt me-1"></i>
                                View on Map
                            </button>
                            <button class="btn btn-success btn-sm" (click)="exportLeads()" [disabled]="filteredLeads.length === 0">
                                <i class="fas fa-download me-1"></i>
                                Export CSV
                            </button>
                        </div>
                    </div>
                </div>

                <div class="card-body">
                    <!-- Filters -->
                    <div class="row mb-4">
                        <div class="col-md-6">
                            <div class="input-group">
                                <span class="input-group-text">
                                    <i class="fas fa-search"></i>
                                </span>
                                <input type="text" class="form-control" placeholder="Search by name, email, or location..." [(ngModel)]="searchTerm" (input)="onSearchChange()" />
                            </div>
                        </div>
                        <div class="col-md-4">
                            <select class="form-select" [(ngModel)]="selectedReason" (change)="onReasonFilterChange()">
                                <option value="">All Reasons</option>
                                <option *ngFor="let reason of getReasonKeys()" [value]="reason">
                                    {{ getReasonLabel(reason) }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-outline-secondary w-100" (click)="clearFilters()">
                                <i class="fas fa-times me-1"></i>
                                Clear
                            </button>
                        </div>
                    </div>

                    <!-- Loading State -->
                    <div *ngIf="loading" class="text-center py-5">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <p class="mt-2 text-muted">Loading leads...</p>
                    </div>

                    <!-- No Results -->
                    <div *ngIf="!loading && filteredLeads.length === 0" class="text-center py-5">
                        <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                        <h5 class="text-muted">No leads found</h5>
                        <p class="text-muted">
                            <span *ngIf="searchTerm || selectedReason">Try adjusting your filters.</span>
                            <span *ngIf="!searchTerm && !selectedReason">No parking leads have been submitted yet.</span>
                        </p>
                    </div>

                    <!-- Leads Table -->
                    <div *ngIf="!loading && filteredLeads.length > 0" class="table-responsive">
                        <table class="table table-hover">
                            <thead class="table-light">
                                <tr>
                                    <th>Date</th>
                                    <th>Contact</th>
                                    <th>Location</th>
                                    <th>Requirements</th>
                                    <th>Reason</th>
                                    <th>Comments</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let lead of filteredLeads; trackBy: trackByLeadId">
                                    <td>
                                        <small class="text-muted">{{ formatDate(lead.createdAt) }}</small>
                                    </td>
                                    <td>
                                        <div>
                                            <strong>{{ lead.name }} {{ lead.surname }}</strong>
                                        </div>
                                        <div class="text-muted small"><i class="fas fa-envelope me-1"></i>{{ lead.email }}</div>
                                        <div class="text-muted small"><i class="fas fa-phone me-1"></i>{{ lead.phoneNumber }}</div>
                                    </td>
                                    <td>
                                        <div class="small">
                                            <strong>{{ lead.idealAddress }}</strong>
                                        </div>
                                        <div class="text-muted small" *ngIf="lead.city || lead.province || lead.postalCode">
                                            {{ lead.city }}<span *ngIf="lead.city && (lead.province || lead.postalCode)">, </span>{{ lead.province
                                            }}<span *ngIf="lead.postalCode && (lead.city || lead.province)"> </span>{{ lead.postalCode }}
                                        </div>
                                        <div class="text-muted small" *ngIf="lead.country">
                                            {{ lead.country }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="small" *ngIf="lead.baysRequired || lead.durationInMonths">
                                            <div *ngIf="lead.baysRequired">
                                                <i class="fas fa-car me-1"></i>
                                                <strong>{{ lead.baysRequired }}</strong> bay<span *ngIf="lead.baysRequired > 1">s</span>
                                            </div>
                                            <div *ngIf="lead.durationInMonths">
                                                <i class="fas fa-clock me-1"></i>
                                                <strong>{{ lead.durationInMonths }}</strong> month<span *ngIf="lead.durationInMonths > 1">s</span>
                                            </div>
                                        </div>
                                        <span class="text-muted small" *ngIf="!lead.baysRequired && !lead.durationInMonths"> Not specified </span>
                                    </td>
                                    <td>
                                        <span class="badge bg-secondary">
                                            {{ leadReasonLabels[lead.reasonForNotFinding] }}
                                        </span>
                                    </td>
                                    <td>
                                        <div class="small" *ngIf="lead.additionalComments">
                                            {{ lead.additionalComments | slice: 0:100 }}
                                            <span *ngIf="lead.additionalComments.length > 100">...</span>
                                        </div>
                                        <span class="text-muted small" *ngIf="!lead.additionalComments"> No comments </span>
                                    </td>
                                    <td class="text-center">
                                        <div class="btn-group btn-group-sm">
                                            <button class="btn btn-outline-info" [title]="'View location on map'" *ngIf="lead.latitude && lead.longitude" (click)="viewOnMap()">
                                                <i class="fas fa-map-marker-alt"></i>
                                            </button>
                                            <button class="btn btn-outline-danger" [title]="'Delete lead'" (click)="deleteLead(lead)">
                                                <i class="fas fa-trash"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
